import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['new', 'form', 'trixEditor']

  trixEditorTargetConnected(element) {
    const content = this.data.get('content')
    if (content) {
      this.openNew()
      element.editor.insertHTML(content + ' ')
      this.data.delete('content')
    }
  }

  openNew() {
    let rect = this.element.getBoundingClientRect()
    this.newTarget.style.top = rect.top + window.pageYOffset + 'px'
    this.newTarget.style.display = 'block';
    this.trixEditorTarget.focus()
  }

  closeNew(event) {
    if(event) {
      event.preventDefault()
    }
    this.newTarget.style.display = 'none'
    this.formTarget.reset()
  }

  resetForm() {
    this.formContainerTarget.innerHTML = this.formContainerTarget.dataset.contentLoaderHtml
  }

}
